// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bcc35970","609":"5ca272da","625":"28975508","649":"d0a4a1d3","652":"5fa066b1","674":"0d8179f0","863":"7c551877","872":"2af8c2c8","900":"5f89728a"}[chunkId] + ".chunk.js";
};